import { gql } from "apollo-boost";

export default gql`
  query CurrentUser {
    currentUser {
      id
      name
      email
      role
      intercomUserHash
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/CurrentUser.js